import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import {
    collection,
    query,
    where,
    orderBy,
    onSnapshot,
    startAt,
    endAt,
} from "firebase/firestore";
import { db } from "../../firebase";
import moment from "moment";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    IconButton,
    List,
    Typography,
    useTheme,
    Grid
} from "@mui/material";
import DashboardPageHeader from '../../components/includes/DashboardPageHeader';
import SearchBar from '../../components/includes/SearchBar';
import { endOfMonth, startOfMonth } from '../../data';

const RedacteurDetails = () => {
    const params = useParams();
    const [articles, setArticles] = useState({});
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const theme = useTheme()
    const navigate = useNavigate();

    useEffect(() => {
        if (!db) return; // Attendre que Firestore soit initialisé
        const colRef = collection(db, "articles");
        const q = query(
            colRef,
            where("author", "==", params.id),
            orderBy("createdAt"),
            startAt(startOfMonth),
            endAt(endOfMonth)
        );


        const unsubscribe = onSnapshot(q, (snapshot) => {
            let content = [];
            if (snapshot.docs) {
                snapshot.docs.forEach((doc) =>
                    content.push({ id: doc.id, ...doc.data() })
                );
                setArticles(content);
                setData(content);
            }
        });

        // Unsubscribe from events when no longer in use
        return () => unsubscribe();
    }, []);

    const searchFilter = (text) => {
        const newData =
            articles &&
            articles.filter((item) => {
                const itemData = item.content
                    ? item.content.toUpperCase()
                    : "".toUpperCase();
                const textData = text.toUpperCase();
                return itemData.indexOf(textData) > -1;
            });
        setSearch(text);
        setData(newData);
    };


    return (
        <main>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <DashboardPageHeader title={"Articles"} />
                </Grid>
                <Grid item xs={12}>
                    <SearchBar
                        searchFilter={searchFilter}
                        placeholder={"Rechercher un article..."}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                sx={{ p: 3 }}
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
                direction={"row"}
                spacing={1}
            >
                <Grid sx={{ p: 3 }} item xs={12}>
                    <Typography variant="h6">
                        {articles && articles.length} article(s) redigé(s) ce mois
                    </Typography>
                </Grid>
                {data &&
                    data.map((article) => (
                        <Grid item xs={12} md={4}>
                            <Card elevation={0}>
                                <CardMedia
                                    component="img"
                                    alt="Formation image"
                                    height="200"
                                    src={article.images ? article.images[0] : article.image}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {article.title}
                                    </Typography>
                                    <Typography sx={{ backgroundColor: theme.palette.primary.main, color: 'white', width: '30%', textAlign: 'center', borderRadius: 4 }}>{article.rubrique}</Typography>

                                </CardContent>
                                <CardActions>
                                    <Button color="primary" sx={{ borderRadius: 10 }}>
                                        {moment(article.createdAt).fromNow()}
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
            </Grid>
        </main>
    )
}

export default RedacteurDetails